$(document).ready(function() {
  if ($(window).scrollTop() == 0) {
        $('.pdp-images').css('opacity', 1);
  }
  
  var isParallax = false;
  if ($('.pdp-case .case').length) isParallax = true;
  
  var caseBottom, caseBottomPosition, parallaxStart, parallaxEnd, parallaxHeight, caseTopParallaxHeight, caseBottomParallaxHeigh;
  if (isParallax) {
    caseBottom = $('.pdp-case .case .bottom');
    caseBottomPosition = caseBottom.offset().top + caseBottom.height();
    parallaxStart = caseBottomPosition - $(window).height();
    parallaxEnd = caseBottomPosition - caseBottom.height() - $('header').outerHeight();
    parallaxHeight = parallaxEnd - parallaxStart;
    caseTopParallaxHeight = +$('.pdp-case .case .top').css('top').replace('px', '');
    caseBottomParallaxHeight = $('.pdp-case .case').height() - +$('.pdp-case .case .bottom').css('top').replace('px', '') - $('.pdp-case .case .bottom').height();
  }
  
  $(window).on('scroll', function() {
    if ($(window).width() >= 1000) {
      var imagesHeight = $('.pdp-images').outerHeight();
      var planHeight = $('.add-to-cart .plan').outerHeight();
      var headerHeight = $('header').outerHeight();
      var formPosition = $('.pdp-main').outerHeight();
      if ($(window).scrollTop() < (formPosition - imagesHeight)) {
//           $('.pdp-images').css('opacity', 1);
          $('.pdp-images').css('position', 'fixed').css('top', headerHeight).css('bottom', 'auto');
      } else {
//         if ($('.pdp-images').css('opacity') == 1) {
//           $('.pdp-images').css('opacity', 0);
//           var t = setTimeout(function() {
            $('.pdp-images').css('position', 'absolute').css('bottom', '0').css('top', 'auto');
//             clearTimeout(t);
//           }, 200);
//         }
      }
    }
    if (isParallax) {
          
      var top = $(window).scrollTop();
      if (top > parallaxStart && top < parallaxEnd) {
        var parallaxTop = top - parallaxStart;
        if (parallaxTop < parallaxHeight * 0.2) {
          var caseTopPercent = parallaxTop * 100 / (parallaxHeight * 0.2);
          $('.pdp-case .case .top').css('top', (caseTopParallaxHeight / 100 * (100-caseTopPercent)) + 'px');
        }
        if (parallaxTop > parallaxHeight * 0.15 && parallaxTop < parallaxHeight * 0.6) {
          var caseBottomPercent = (parallaxTop - parallaxHeight * 0.15) * 100 / (parallaxHeight * 0.45);
          $('.pdp-case .case .bottom').css('transform', 'translateY(' + (caseBottomParallaxHeight / 100 * caseBottomPercent) + 'px)');
          $('.pdp-case .case .bottom-back').css('transform', 'translate(-50%,' + (caseBottomParallaxHeight / 100 * caseBottomPercent) + 'px)');
        }
      } else if (top < parallaxStart) {
        if ($(window).width() < 1000) {
          $('.pdp-case .case .top').css('top', $(window).width() / 100 * 29.5 + 'px');
        } else {
          $('.pdp-case .case .top').css('top', $(window).width() / 100 * 9.028 + 'px');
        }
        $('.pdp-case .case .bottom').css('transform', 'none');
        $('.pdp-case .case .bottom-back').css('transform', 'translateX(-50%)');
      } else if (top > parallaxStart) {
        $('.pdp-case .case .top').css('top', '0px');
        $('.pdp-case .case .bottom').css('transform', 'translate(-50%,' + caseBottomParallaxHeight + ')');
        $('.pdp-case .case .bottom-back').css('transform', 'translateY(' + caseBottomParallaxHeight + ')');
      }
    }
  });
  
  $('.pdp-images').slick({
    arrows: true,
    dots: true,
    fade: true,
  });
  
  $('.pdp-images img, .pdp-images .image').click(function() {
    $('.pdp-images').slick('slickNext');
  });
  
  const prevArrow = `<button class="slick-prev slick-arrow" aria-label="Previous" type="button">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 33">
      <path fill="none" stroke="#FFF" stroke-width="3" d="M17.5 1.5l-15 15 15 15"/>
    </svg>
  </button>`;

  const nextArrow = `<button class="slick-next slick-arrow" aria-label="Next" type="button">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 33">
      <path fill="none" stroke="#FFF" stroke-width="3" d="M1.5 31.5l15-15-15-15"/>
    </svg>
      </button>`;
  
  jQuery.ajax({
    type: 'GET',
    url: 'https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/yotpo_site_reviews/reviews.json?per_page=7',
    dataType: 'json',
    success: function(data) { 
      const res = data.response;
      let reviewStarsArray = '';
      let num = res.bottomline.star_distribution[4] + res.bottomline.star_distribution[5];
      const average_score = (res.bottomline.star_distribution[4]*4 + res.bottomline.star_distribution[5]*5) / num;
      for (let i = 0; i < 5; i++) {
        if ((average_score - i) >= 1) reviewStarsArray += `<div class="star"></div>`;
        else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<div class="star half"></div>`;
      }
      total = '(' + res.bottomline.total_review + (res.bottomline.total_review > 1 ? ' Reviews' : ' Review') + ')';
      $('.reviews-stars').html(reviewStarsArray + '<a href="/pages/reviews">' + total + '</a>');
        $('.pdp-content .product-reviews-stars').html('<a href="/pages/reviews">' + reviewStarsArray + '<span>(' + num + ' Reviews)</span></a>');
      
      var average = res.bottomline.average_score.toFixed(1) + ' stars';
      $('.pdp-content .reviews-stars-pdp').html('<a href="/pages/reviews">' + average + '<span>(' + res.bottomline.total_review + ' reviews)</span></a>');

      if ($('#reviews-slider').length) {
          var reviews = res.reviews;
          var reviewsHtml = '';
          var limit = 180;
          for (var i=0; i<reviews.length; i++) {
            if (reviews[i].score > 3) {
              var content = reviews[i].content;
              if (content.length > limit) {
                content = content.slice( 0, limit);
                lastSpace = content.lastIndexOf(" ");
                if( lastSpace > 0) {
                  content = content.substr(0, lastSpace);
                }
                content += '...';
              }
              var review = `
				<div class="review">
					<div class="content">
                      ${content}
                    </div>
					<div class="author">
                      ${reviews[i].user.display_name}
                    </div>
                </div>
              `;
              reviewsHtml += review;
            }
          }
          
          $('#reviews-slider').html(reviewsHtml);
          $('#reviews-slider').slick("unslick");
          $('#reviews-slider').slick({
            mobileFirst: true,
            speed: 500,
            infinite: false,
            arrows: false,
            dots: true,
            adaptiveHeight: true,
            responsive: [{
              breakpoint: 1000,
              settings: {
                adaptiveHeight: false,
                fade: true,
              }
            }]
          });
      }
    },
    error: function(){
      console.log('Error');
    }
  });

   $('.pdp-quick-shop .product-reviews-stars').each(function() {
    var div = $(this);
    var url;
//     var deodorantProducts = ['833527709732', '833511915556', '833527414820', '833528528932', '833526923300', '5743593226394', '5743609086106', '5743595389082', '5743595389082'];
    var washProducts = ['7130386301082', '7130387513498', '7130388955290'];
    var link = $(this).attr('data-url');
    if ($(this).attr('data-id') == 7250571165850 || $(this).attr('data-id') == 7114026057882) {
      url = 'https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/yotpo_site_reviews/reviews.json?per_page=7';
    } else if ($(this).attr('data-id') == 7114026647706 || $(this).attr('data-id') == 7114024255642) {
      getReviews(washProducts, div);
      return;
    } else {
      url = `https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/${div.attr('data-id')}/reviews.json?per_page=150`;
    }
    jQuery.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: function(data) { 
        const res = data.response;
        console.log(res)
        if (res && res.reviews.length && res.bottomline.total_review > 3) {
          let reviewStarsArray = '';
          let num = res.bottomline.star_distribution[4] + res.bottomline.star_distribution[5];
          const average_score = (res.bottomline.star_distribution[4]*4 + res.bottomline.star_distribution[5]*5) / num;
          for (let i = 0; i < 5; i++) {
            if ((average_score - i) >= 1) reviewStarsArray += `<div class="star"></div>`;
            else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<div class="star half"></div>`;
          }
          div.html('<a href="' + link + '">' + reviewStarsArray + '<span>(' + num + ')</span></a>');
        } else {
          div.hide(0);
        }
      },
      error: function(){
        console.log('Error');
      }
    })
  });
  
  function getReviews(ids, div) {
    var counter = 0;
    var average = 0;
    var num = 0;
    var link = div.attr('data-url');
    for (var i=0; i<ids.length; i++) {
      url = `https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/${ids[i]}/reviews.json?per_page=150`;
      jQuery.ajax({
        type: 'GET',
        url: url,
        dataType: 'json',
        success: function(data) { 
          const res = data.response;
          if (res.reviews.length) {
            var review_num = res.bottomline.star_distribution[4] + res.bottomline.star_distribution[5];
            num += review_num;
            average += (res.bottomline.star_distribution[4]*4 + res.bottomline.star_distribution[5]*5) / review_num;
            counter++;
            if (counter == ids.length) {
              var average_score = average / ids.length;
              let reviewStarsArray = '';
              for (let i = 0; i < 5; i++) {
                if ((average_score - i) >= 1) reviewStarsArray += `<div class="star"></div>`;
                else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<div class="star half"></div>`;
              }
              div.html('<a href="' + link + '">' + reviewStarsArray + '<span>(' + num + ')</span></a>');
              div.show(0);
            }
          } 
        },
        error: function(){
          console.log('Error');
        }
      });
    }
  }
  
  if ($(window).width() < 1000) {
    $('.scents-carousel').scrollLeft($('.pdp-scents .scent').width()/2);
  }
  
  $('.pdp-ingredients .tab .title, .popup .tab .title ').click(function() {
    $(this).siblings('.text').slideToggle(200);
    $(this).toggleClass('opened');
  });
  
  $('.pdp-case .tab .title').click(function() {
    if ($(window).width() < 1000) {
      $(this).siblings('.text').slideToggle(200);
    } else {
      $(this).siblings('.text').fadeToggle(200);
      $(this).closest('.tab').siblings('.tab').find('.text').fadeOut(200);
    }
  });

  $('.promotional-carousel').slick({
    speed: 300,
    autoplaySpeed: 9000,
//     autoplay: true,
    arrows: false,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplaySpeed: 3000,
          centerMode: false,
          variableWidth: false,
          arrows: false
        }
      }
    ]
  });
  
  $('.video .poster').click(function() {
    $(this).siblings('video')[0].play();
    $(this).remove();
  });
  
  $('.pdp-quick-shop .products').slick({
    mobileFirst: true,
    centerMode: true,
    variableWidth: true,
    responsive: [{
      breakpoint: "1000",
      settings: "unslick"
    }]
  });
  
  var w = $(window).width();
  $(window).resize(function() {
    if (w != $(window).width()) {
      if ($(window).width() < 1000) {
        $('.pdp-case .case .top').css('top', $(window).width() / 100 * 29.5 + 'px');
      } else {
        $('.pdp-case .case .top').css('top', $(window).width() / 100 * 9.028 + 'px');
      }
      $('.pdp-case .case .bottom').css('transform', 'none');
      $('.pdp-case .case .bottom-back').css('transform', 'translateX(-50%)');
      if (w >= 1000 && $(window).width() < 1000) {
        $('.homepage-quick-shop .products').slick('unslick');
        $('.homepage-quick-shop .products').slick({
          mobileFirst: true,
          centerMode: true,
          variableWidth: true,
          responsive: [{
            breakpoint: "1000",
            settings: "unslick"
          }]
        });
      }

      window.resizedFinished = setTimeout(function(){
        if (isParallax) {
          caseBottom = $('.pdp-case .case .bottom');
          caseBottomPosition = caseBottom.offset().top + caseBottom.height();
         parallaxStart = caseBottomPosition - $(window).height();
          parallaxEnd = caseBottomPosition - caseBottom.height() - $('header').outerHeight();
          parallaxHeight = parallaxEnd - parallaxStart;
          caseTopParallaxHeight = +$('.pdp-case .case .top').css('top').replace('px', '');
          caseBottomParallaxHeight = $('.pdp-case .case').height() - +$('.pdp-case .case .bottom').css('top').replace('px', '') - $('.pdp-case .case .bottom').height()
        }
        clearTimeout(window.resizedFinished);
      }, 500);


      if ($(window).width() < 1000) {
        $('.scents-carousel').scrollLeft($('.pdp-scents .scent').width()/2);
      }
    }
    w = $(window).width();
  
  });
  
  $('.pick-formula .formula').click(function() {
    if (!$(this).hasClass('active')) {
      $(this).addClass('active');
      var scents = $('.pick-scent .scents').eq($(this).index());
      scents.addClass('active');
      scents.find('.was-selected').addClass('active');
    } else {
      $(this).removeClass('active');
      var scents = $('.pick-scent .scents').eq($(this).index());
      scents.removeClass('active');
      scents.find('.scent').removeClass('active');
    }
    updateProductList();
  });
  
  function updateProductList() {
    $('.add-to-cart .plan .products').html('');
    var html = '';
    var totalDiscount = 0;
    var total = 0;
    var caseActive = $('.case.active');
    var priceSubscription = 0,
        priceOneTime = 0;
    $('.scents.active .scent.active').each(function() {
      var price = +($(this).attr('data-price').replace('$', ''));
      var priceDiscount = price * 0.75;
      var quantity = +$(this).find('.quantity .num').text();
      var futureQuantity = quantity;
      priceSubscription += priceDiscount*quantity;
      priceOneTime += price*quantity;
    });
    if (!caseActive.hasClass('already-have')) {
      priceSubscription += 3.75;
      priceOneTime += 5;
    }
    $('.add-to-cart .subscription-total').text('$' + priceSubscription);
    $('.add-to-cart .one-time-total').text('$' + priceOneTime);
    
    
    if ($('#plan-subscribe').hasClass('active')) {
      var num = 0;
      $('.scents.active .scent.active').each(function() {
        num += +$(this).find('.quantity .num').text();
      });
      var scentWithMaxPrice;
      var max = 0;
      $('.scents.active .scent.active').each(function() {
        var price = +($(this).attr('data-price').replace('$', ''));
        if (price > max) {
          scentWithMaxPrice = $(this);
          max = price;
        }
      });
      $('.scents.active .scent.active').each(function() {
        var price = +($(this).attr('data-price').replace('$', ''));
        var priceDiscount = price * 0.75;
        var quantity = +$(this).find('.quantity .num').text();
        var futureQuantity = quantity;
        if (num < 3) {
          if ($('.scents.active .scent.active').length == 1) {
            futureQuantity = 3;
          } else if ($('.scents.active .scent.active').length == 2) {
            if ($(this).attr('id') == scentWithMaxPrice.attr('id')) {
              futureQuantity = 2;
            }
          }
        }
        html += `<div class="line" data-id="${$(this).attr('data-id')}">
          <div class="num">${futureQuantity}</div>
          <div class="title">${$(this).find('h3').text()} Formula</div>
          <div class="compare-at-price">$${price*futureQuantity}</div>
          <div class="price">$${priceDiscount*futureQuantity}</div>
        </div>`;
        total += price*quantity;
        totalDiscount += priceDiscount*quantity;
      });
      if (!caseActive.hasClass('already-have')) {
        total += 5;
        totalDiscount += 3.75;
      }
      $('.add-to-cart').removeClass('one-time');
      $('#cart-total-compare').text('$' + total);
      $('#cart-total').text('$' + totalDiscount);
      $('.add-to-cart .subscription-total').text('$' + totalDiscount);
      
      if (totalDiscount < 35) $('.add-to-cart .row .shipping .free').hide(0);
      else  $('.add-to-cart .row .shipping .free').show(0);
    } else {
      num = 3;
      $('.scents.active .scent.active').each(function() {
        var price = +($(this).attr('data-price').replace('$', ''));
        var quantity = +$(this).find('.quantity .num').text();
        html += `<div class="line">
          <div class="num">${quantity}</div>
          <div class="title">${$(this).find('h3').text()} Formula</div>
          <div class="compare-at-price"></div>
          <div class="price">$${price*quantity}</div>
        </div>`;
        total += price*quantity;
      });
      if (!caseActive.hasClass('already-have')) {
        total += 5;
      }
      $('.add-to-cart').addClass('one-time');
      $('#cart-total').text('$' + total);
      $('.add-to-cart .one-time-total').text('$' + total);
      $('#cart-total-compare').text('');
      
      if (total < 35) $('.add-to-cart .row .shipping .free').hide(0);
      else  $('.add-to-cart .row .shipping .free').show(0);
    }
    if (!$('#plan-subscribe').hasClass('active')) {
      html += `<div class="line">
          <div class="num">1</div>
          <div class="title">${caseActive.find('.name').text()} Refillable Case</div>
          <div class="compare-at-price"></div>
          <div class="price">$5</div>
        </div>`;
    }
      $('.add-to-cart .plan .products').html(html);
    if (!caseActive.hasClass('already-have')) {
      $('.add-to-cart .in-order .color').html(caseActive.find('.name').text());
    } else {
      $('.add-to-cart .in-order .color').html('No');
    }
    
    var totalQuantity = 0;
    $('.scent.active').each(function() {
      totalQuantity += +$(this).find('.num').text();
    });
    $('.add-to-cart .in-order .num').html(totalQuantity);
    var n  = (totalQuantity >= 3) ? totalQuantity : 3;
    $('#plan-subscribe .num').html(n);
    if ($('.scent.active').length == 0) 
      $('.add-to-cart .button').attr('disabled', true);
    else $('.add-to-cart .button').attr('disabled', false);
  }
  
  $('.scent').click(function(e) {
    if ($(window).width() < 1000 && $(this).hasClass("selected")) {
      const elem = $(this)
      $(elem).addClass("selected-temp");
      $(elem).removeClass("selected-temp");
	}
    if ($(window).width() > 1000) {
      if ($(this).hasClass("selected")) {
        $(this).closest('.scents-carousel').removeClass("carousel-open");
      } else if ($(this).closest('.scents-carousel').find(".scent.selected").length) {
        $(this).closest('.scents-carousel').addClass("carousel-open");
      } else if (!$(this).closest('.scents-carousel').find(".scent.selected").length && !$(this).closest('.scents-carousel').hasClass("carousel-open")) {
        $(this).closest('.scents-carousel').addClass("carousel-open");
      } else {
        $(this).closest('.scents-carousel').removeClass("carousel-open");
      }
    }
    if ($(this).closest('.scents').hasClass('active')) {
      var div = $(this).find('.quantity');
      if (!div.is(e.target) && div.has(e.target).length === 0) {
        $(this).toggleClass('active');
        $(this).toggleClass('was-selected');
      }
      updateProductList();
    }
  });
  
  $('.scent .plus').click(function() {
    if ($(this).closest('.scents').hasClass('active')) {
      if ($(this).closest('.scent').hasClass('active')) {
        var num = +$(this).siblings('.num').text();
        $(this).siblings('.num').text(++num);
      } else {
        $(this).closest('.scent').addClass('active')
      }
      updateProductList();
    }
  });
  
  $('.scent .minus').click(function() {
    if ($(this).closest('.scents').hasClass('active')) {
      if ($(this).closest('.scent').hasClass('active')) {
      var num = +$(this).siblings('.num').text();
        if (num > 1) $(this).siblings('.num').text(--num);
        else {
          $(this).closest('.scent').removeClass('active');
          $(this).closest('.scent').removeClass('was-selected');
        }
      } else {
        $(this).closest('.scent').addClass('active')
        $(this).closest('.scent').addClass('was-selected');
      }
      updateProductList();
    }
  });
  
  $('.case').click(function() {
    $(this).addClass('active');
    $(this).siblings('.case').removeClass('active');
    var img = $(this).find('.image').attr('data-src');
    if (img) {
      $('.pdp-images .image:first-child img').attr('src', img);
      $('.pdp-images').slick('slickGoTo',0);
    }
    updateProductList();
  });
  
  $('.plan-selection .radio').click(function() {
    $(this).addClass('active');
    $(this).siblings('.radio').removeClass('active');
    if ($(this).hasClass('subscription')) {
      $('.add-to-cart .selected-plan.subscription').addClass('active');
      $('.add-to-cart .selected-plan.one-time').removeClass('active');
      $('.plan .plan-text').show(0);
    }
    if ($(this).hasClass('one-time')) {
      $('.add-to-cart .selected-plan.subscription').removeClass('active');
      $('.add-to-cart .selected-plan.one-time').addClass('active');
      $('.plan .plan-text').hide(0);
    }
    updateProductList();
  });
  
  $('#open-plan').click(function(e) {
    e.preventDefault();
    $('.add-to-cart .plan').fadeToggle(200);
    $(this).toggleClass('opened');
  });
  
//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/clear.js',
//     dataType: 'json',
//     success: function() { 
//     },
//     error: function(e) { 
//       console.log(e)
//     }
//   });
  $('#submit').click(function(e) {
    e.preventDefault();
    var subReplacements = {"12153325387812":"41600892600474", "8986775224356":"41600892633242", "8669491920932":"41600892666010", "31592905015428":"41600892698778", "31592926249092":"41600892731546", "31592917631108":"41600892764314", "32978785108100":"41600892797082", "34424665899162":"41600892829850", "34424674287770":"41600892862618"};
    
    var data;
    var items = [];
    var productType;
    if ($("#MainContent").data('template') == "product.deo-refill" || $("#MainContent").data('template') == "product.deo-refill-v2") {
      productType = 'refill';
    } else {
      productType = 'kit';
    }
    
    if (!$('.case.active').hasClass('already-have')) {
      var caseId = $('.case.active').attr('data-id');
      if ($('#plan-subscribe').hasClass('active')) {
        // if (subReplacements[caseId] && $("#MainContent").data('template') != "product.deo-refill") {
        //   caseId = subReplacements[caseId];
        // }
          var plan = $('.case.active').data('plan');
          var items = [
            {
              quantity: 1,
              id: caseId,
              selling_plan: plan,
              properties: {
                // 'shipping_interval_unit_type': 'Months',
                // 'shipping_interval_frequency': 365,
                // 'subscription_id': 2295389,
                // 'plan_type': 'subscribe-and-save',
                'is_subscription': true,
                'subscription_quantity': 1,
                'price_without_discount': '$5',
                'product_type': productType
              }
            }
          ];
      } else {
        var items = [
            {
              quantity: 1,
              id: caseId,
              properties: {
                'product_type': productType
              }
            }
          ];
      }
    }

    if ($('#plan-subscribe').hasClass('active')) {
//       var packId = getPackId();
//       if (packId == 0) {
//         console.log('error');
//         return;
//       }
//       var skus = getSKUs();
//       data = {
//         items: [
//         {
//           quantity: 1,
//           id: caseId
//         },
//         {
//           quantity: 1,
//           id: packId,
//           properties: {
//             'shipping_interval_unit_type': 'Months',
//             'shipping_interval_frequency': 3,
//             'subscription_id': 132269,
//             'plan_type': 'subscribe-and-save',
//             'is_subscription': true,
//             ...skus
//           }
//         }
//       ]}
      
      $('.scent.active').each(function() {
        var id = $(this).attr('data-id');
        var quantity = +$(this).find('.num').text();
        var plan = $(this).attr('data-plan');
        var subscriptionQuantity = +$(`.add-to-cart .plan .line[data-id=${$(this).attr('data-id')}]`).find('.num').text();
        items.push({
          quantity: quantity,
          id: id,
          selling_plan: plan,
          properties: {
            // 'shipping_interval_unit_type': 'Months',
            // 'shipping_interval_frequency': 3,
            // 'subscription_id': 132269,
            // 'plan_type': 'subscribe-and-save',
            'is_subscription': true,
            'subscription_quantity': subscriptionQuantity,
            'price_without_discount': $(this).attr('data-price'),
            'product_type': productType
          }
        });
      });
    } else {
      $('.scent.active').each(function() {
        var id = $(this).attr('data-id');
        var quantity = +$(this).find('.num').text();
        items.push({
          quantity: quantity,
          id: id,
          properties: {
            'is_subscription': false,
            'product_type': productType
          }
        });
      });
    }
    data = {
      items: items
    }
    
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
        console.log("Add product.js");
        window.getCart();
      },
      error: function(e) { 
        console.log(e.responseText)
      }
    });
  });
  /*function getCart() {
    $('#cart .items').html('');
    jQuery.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(data) { 
        var items = data.items;
        for (var i=0; i<items.length; i++) {
          var subscription = '';
          var isOneTime = true;
          if (items[i].properties && items[i].properties.is_subscription == 'true') {
            subscription = 'subscription';
            isOneTime = false;
          }
          var product = `
            <div class="item ${subscription}" data-one-time="${isOneTime}">
              <div class="image">
                <img src="${items[i].featured_image.url}">
              </div>
              <div class="title">
                ${items[i].title.replace('</br>', ' ')}
                <div class="price">
                  $${(items[i].final_price/100).toFixed(2)}
                </div>
              </div>
              <div class="quantity">
				<span class="minus control">-</span>
                <input
                  type="text"
                  name="updates[]"
                  size="4"
                  id="${items[i].id}"
                  value="${items[i].quantity }"
                />
				<span class="plus control">+</span>
              </div>
            </div>`;
          $('#cart .items').append(product);
        }
        
        $('#cart .total .price').text('$' + (data.total_price/100).toFixed(2));
        
        if ($('.item.subscription').length) setCartDiscount();
        $('#cart').addClass('opened');
        $('#cart + .dark-bg').addClass('shown');

        $('#cart .quantity input').keyup(function() {
          var data = {
            'id': $(this).attr('id'),
            'quantity': $(this).val()
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function() { 
            },
            error: function(){
              console.log('Error');
            }
          });
        });

        $('#cart .quantity .plus').click(function() {
          var input = $(this).siblings('input');
          var quantity = +input.val();
          var data = {
            'id': input.attr('id'),
            'quantity': ++quantity
          }
          jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            success: function() { 
              input.val(quantity++);
              var total = 0;
              $('#cart .item').each(function() {
                var price = +$(this).find('.price').text().replace('$', '');
                total += price * (+$(this).find('.quantity input').val());
              });
              $('#cart .total .price').html('$' + total);
            },
            error: function(){
              console.log('Error');
            }
          });
        });
        
        $('#cart .quantity .minus').click(function() {
          var input = $(this).siblings('input');
          var quantity = +input.val();
          if (quantity > 0) {
            var data = {
              'id': input.attr('id'),
              'quantity': --quantity
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: data,
              dataType: 'json',
              success: function() { 
                input.val(quantity--);
                var total = 0;
                $('#cart .item').each(function() {
                  var price = +$(this).find('.price').text().replace('$', '');
                  total += price * (+$(this).find('.quantity input').val());
                });
                $('#cart .total .price').html('$' + total);
              },
              error: function(){
                console.log('Error');
              }
            });
          }
        });
      },
      error: function(e) { 
        console.log(e.responseText)
      }
    });
  }*/
  
  function setCartDiscount() {
    var total = 0;
    $('#cart .item').each(function() {
      var price = +$(this).find('.price').text().replace('$', '');
      if ($(this).attr('data-one-time') == 'true') {
        var discountPrice = price*0.75;
        $(this).find('.price').html('$' + discountPrice);
        total += discountPrice * (+$(this).find('.quantity input').val());
      } else {
        total += price * (+$(this).find('.quantity input').val());
      }
    });
    $('#cart .total .price').html('$' + total);
  }
  
  function getPackId() {
    const ScentComboToPrice = {
      "30": 36432758079642,
      "32": 36432758112410,
      "34": 36432758145178,
      "36": 36432758177946
    }
    var myroCounter = 0;
    $('#scents-natural .scent.active, #scents-sensitive .scent.active').each(function() {
      myroCounter += +$(`.add-to-cart .plan .products .line[data-id=${$(this).attr('data-id')}]`).find('.num').text();
    });
    var myroPlusCounter = 0;
    $('#scents-performance .scent.active').each(function() {
      myroPlusCounter += +$(`.add-to-cart .plan .products .line[data-id=${$(this).attr('data-id')}]`).find('.num').text();
    });
    
    if (myroCounter == 3 && myroPlusCounter == 0) return ScentComboToPrice['30'];
    else if (myroCounter == 2 && myroPlusCounter == 1) return ScentComboToPrice['32'];
    else if (myroCounter == 1 && myroPlusCounter == 2) return ScentComboToPrice['34'];
    else if (myroCounter == 0 && myroPlusCounter == 3) return ScentComboToPrice['36'];
    else return 0;
  }
  
  function getSKUs() {
    var skus = {};
    var counter = 0;
    $('.scent.active').each(function() {
      var num = +$(this).find('.num').text();
      for (var i=0; i<num; i++) {
        skus[counter] = $(this).attr('data-sku');
        counter++;
      }
    });
    return skus;
  }
    
  function reChargeProcessCart() {
    function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
      do {
            token=get_cookie('cart');
      }
      while(token == undefined);
      var myshopify_domain='serface.myshopify.com'
      try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
      var customer_param = ''
      return 'https://checkout.mymyro.com/r/checkout?myshopify_domain=' + myshopify_domain + '&cart_token='+token+'&'+ga_linker+'&'+customer_param;
  }
    $('#open-scent-popup').click(function(e) {
      e.preventDefault();
      $('#scent-popup').fadeIn(200);
      if ($(window).width() < 1000) {
        $('#scent-popup .scents-carousel').scrollLeft($('#scent-popup .scent').width()/2);
      }
    });
    $('#open-formula-popup').click(function(e) {
      e.preventDefault();
      $('#formulas-popup').fadeIn(200);
    });
    $('#open-case-popup').click(function(e) {
      e.preventDefault();
      $('#case-popup').fadeIn(200);
    });
  
    $('#ingredients-open-popup').click(function(e) {
      e.preventDefault();
      $('#formulas-popup').fadeIn(200);
    });
    $('.popup .close').click(function() {
      $('.popup').fadeOut(200);
    });
  
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  var resetScents = false;
  
  $(".scent").each(function() {
    var id = $(this).data("id");
    if (urlParams.get(id)) {
      if (!resetScents) {
        resetAllScents();
        resetScents = true;
      }
      $(this).addClass("active");
      $(this).addClass("was-selected");
      $(this).find(".num").html(urlParams.get(id));
    }
  });
  
  function resetAllScents() {
  	$(".scent").each(function() {
      var id = $(this).data("id");
        $(this).removeClass("active");
        $(this).removeClass("was-selected");
        $(this).find(".num").html(0);
    });
  }
  
  $(".formula").each(function() {
    var id = $(this).attr("id");
    console.log(id);
    console.log(urlParams.get(id));
    if (urlParams.get(id) == "false") {
      $(this).removeClass("active");
    }
  });
  
  var caseType = urlParams.get("case");
  $(".case").each(function() {
    var id = $(this).data("id");
    if (id == caseType) {
      $(this).click();
    }
  });
  
  var sub = urlParams.get("subscription");
  
  if (sub == "false") {
  	$("#plan-onetime").click();
  }
      
  updateProductList();
  
  if ($('.review-badges').length) {
    var totalScore = 0;
    var reviewNum = 0;
    var badgeNum = 0;
    $(this).find('.jdgm-widget').each(function() {
      var data = $(this).find('.jdgm-prev-badge');
      totalScore += +data.data('average-rating');
      reviewNum += +data.data('number-of-reviews');
      badgeNum++;
    });
    var average_score = totalScore / badgeNum;
    var reviewStarsArray = '';
    for (var i=0; i<5; i++) {
      if ((average_score - i) >= 1) reviewStarsArray += `<span class="jdgm-star jdgm--on"></span>`;
      else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<span class="jdgm-star jdgm--half"></span>`;
      else if ((average_score - i) < 0)  reviewStarsArray += `<span class="jdgm-star jdgm--off"></span>`;
    }
    var widget = `<div style="" class="jdgm-widget jdgm-preview-badge jdgm-hidden jdgm--done-setup" data-template="manual-installation" data-auto-install="false">
    <div class="jdgm-prev-badge">
    <span class="jdgm-prev-badge__stars"role="button">${reviewStarsArray}</span>
    <span class="jdgm-prev-badge__text">${reviewNum} reviews</span>
    </div></div>`;
    if (reviewNum) {
      $('.review-badges').after(widget);
    }
  }

  $('.jdgm-prev-badge').click(function(e) {
    e.preventDefault();
   $('html, body').animate({
      scrollTop: $('#shopify-section-pdp-reviews').offset().top
    }, 500);
  })
});